<script lang="ts">
    import {Button, Hr, Spinner} from "flowbite-svelte";
    import EmployeeTodos from "$lib/partials/employee/EmployeeTodos.svelte";
    import FullCalender from "$lib/components/FullCalender.svelte";
    import type {Calendar} from "@fullcalendar/core";
    import {onMount} from "svelte";
    import {page} from "$app/stores";
    import type {HrReminders} from "$lib/types/reminders";
    import type {HrTodos} from "$lib/types/todos";
    import type {EmployeeCount} from "$lib/types/employee";
    import {user} from "$lib/stores/auth";
    import Timeline from "$lib/components/Timeline.svelte";
    import {employeeStatus} from "$lib/options";
    import MailjetStatus from "$lib/partials/employee/MailjetStatus.svelte";
    import dayjs from "dayjs";
    import GlobalShortcuts from "$lib/components/GlobalShortcuts.svelte";
    let hrTodos: HrTodos;
    let hrReminders: HrReminders = $page.data.hrReminders;

    let employeeCount: EmployeeCount;
    let calendar: Calendar;
    onMount(async () => {
        if (!hrTodos){
            hrTodos = await $page.data.delayed?.hrTodos;
        }
        $page.data.delayed.hrReminders.then(hrReminders => {
            (hrReminders.employeeReminders || []).forEach(reminder => {
                calendar.addEvent({
                    title: reminder.note.split('<')[0],
                    start: dayjs.unix(reminder.remindAt.stamp).format('YYYY-MM-DD HH:mm'),
                    extendedProps: {
                        type: 'employeeReminders', // type and the full information; will display: note, date (due), done or not, employee name
                        object: reminder,
                        title: "Reminder"
                    }
                });
            });

            hrTodos.contractSignatures?.waitingForHR?.forEach(todo => {
                calendar.addEvent({
                    title: todo.contract.employee.firstName + ' ' + todo.contract.employee.lastName, // employee name, link to the signature
                    start: new Date(),
                    extendedProps: {
                        type: 'waitingForHr',
                        object: todo,
                        title: "Contract Signature"
                    }
                });
            });
        })

    });
</script>
<svelte:head>
    <title>HR</title>
</svelte:head>
<GlobalShortcuts/>
<div class="w-full flex gap-3 place-items-center justify-center mt-5">
<!--    <img src="/img/ci/button_recrew_solid_black.svg" class="h-20" alt="bildmarke">-->
    <img src="/img/ci/recrew_black.svg" class="h-14" alt="bildmarke">

</div>

<h1 class="text-2xl leading-7 text-neutral-600 my-12 text-center">Welcome, {$user?.associations[0]?.name || 'Nutzer'}</h1>
<Hr/>
<h1 class="text-2xl leading-7 text-neutral-600 my-12">Recruiting Status</h1>
<section class="flex flex-col gap-16">
    <div class="flex gap-8 flex-wrap flex-col lg:flex-row justify-between items-center">
        {#if $page.data.delayed}
            {#await $page.data.delayed.employeeCount}
                <Spinner/>
            {:then employeeCount}
                <div class="flex-1 grid grid-cols-5 gap-12">
                    {#each Object.entries(employeeStatus).filter(([key]) => !['active', 'data-re-requested','data-re-provided', 'rebuddy', 'inactive', 're-offered'].includes(key)) as [key, name]}
                        {#if key !== 'onboarding'}
                            <div class="flex items-center gap-3">
                                <Button size="sm" href="/employees/list?filter%5BemploymentStatus%5D={key}" class="w-12">
                                    {employeeCount[key]}
                                </Button>
                                <span class="text-neutral-600 text-sm">{name}</span>
                            </div>
                        {/if}
                    {/each}
                </div>
            {/await}
        {/if}
    </div>

</section>
<Hr/>
<h1 class="text-2xl leading-7 text-neutral-600 my-12">Wiedereintritt Status</h1>
<section class="flex flex-col gap-16">
    <div class="flex gap-8 flex-wrap flex-col lg:flex-row justify-between items-center">
        {#if $page.data.delayed}
            {#await $page.data.delayed.employeeCount}
                <Spinner/>
            {:then employeeCount}
                <div class="flex-1 grid grid-cols-5 gap-12">
                    {#each ['data-re-requested','data-re-provided', 're-offered', 'inactive'] as key}
                        <div class="flex items-center gap-3">
                            <Button size="sm" href="/employees/list?filter%5BemploymentStatus%5D={key}" class="w-12">
                                {employeeCount[key]}
                            </Button>
                            <span class="text-neutral-600 text-sm">{employeeStatus[key]}</span>
                        </div>
                    {/each}
                </div>
            {/await}
        {/if}
    </div>

</section>
<Hr/>
<h1 class="text-2xl leading-7 text-neutral-600 my-12">Aktiver Mitarbeiter Status</h1>
<section class="flex flex-col gap-16">
    <div class="flex gap-8 flex-wrap flex-col lg:flex-row justify-between items-center">
        {#if $page.data.delayed}
            {#await $page.data.delayed.employeeCount}
                <Spinner/>
            {:then employeeCount}
                <div class="flex-1 grid grid-cols-5 gap-12">
                    {#each ['rebuddy', 'active'] as key}
                        <div class="flex items-center gap-3">
                            <Button size="sm" href="/employees/list?filter%5BemploymentStatus%5D={key}" class="w-12">
                                {employeeCount[key]}
                            </Button>
                            <span class="text-neutral-600 text-sm">{employeeStatus[key]}</span>
                        </div>
                    {/each}
                </div>
            {/await}
        {/if}
    </div>

</section>
<Hr/>
<h2 class="text-2xl leading-7 text-neutral-600 my-12">Kalender</h2>
<FullCalender bind:calendar/>
<Hr/>
<h2 class="text-2xl leading-7 text-neutral-600 my-12">Offene Erinnerungen</h2>
<EmployeeTodos {hrTodos}/>
<h2 class="text-2xl leading-7 text-neutral-600 my-12">Mailjet Status</h2>
<div class="w-full">
    <MailjetStatus/>
</div>